import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { Row, Col, Card } from 'react-bootstrap';
import { SearchInput } from '../../widgets';
import { searchWord, isElasticLoad } from '../../../helpers/common';
import { Unit } from '../../../helpers/unit';
import LoadingStyle from '../Common/LoadingStyle';
import { DISPLAY_DATE_FORMAT2, HARVEST_WORK_TYPE_IDS } from '../../../constants';
import moment from 'moment';
import UtilizationModal from './UtilizationModal';
import AllUtilizationModal from './AllUtilizationModal';

const NonTruckList = (props) => {
  const {
    selectedWorkTypeIds: activeWorkType,
    egList: { isRequesting: isRequestingEg },
    sourceListById: { isRequestingLoad, isRequestingKpi, payload: sourceDetailsById },
  } = useSelector((state) => state.dashboard.leaderBoard);

  const searchParams = useSelector((state) => state.analyze.searchParams);
  const egReportIssue = useSelector((state) => state.equipmentGroup.EGReportIssue.list);
  const [searchText, setSearchText] = useState("");
  const [show, setShow] = useState(false);
  const [isMultipleDate, setMultipleDate] = useState(false);
  const [egId, setEgId] = useState(null);
  const [isAll, setAll] = useState(false);
  const unit = Unit.getInstance();

  const sourceDetailList = Object.keys(sourceDetailsById).map((id) => sourceDetailsById[id])

  useEffect(() => {
    const fromDate = moment(searchParams.custom.from).format(DISPLAY_DATE_FORMAT2);
    const toDate = moment(searchParams.custom.to).format(DISPLAY_DATE_FORMAT2);

    if (fromDate === toDate) {
      setShow(false);
      setMultipleDate(false);
    } else {
      setMultipleDate(true);
    }

    if (searchParams.customRange === "todate" || searchParams.customRange === "planned") {
      setMultipleDate(true);
    }
  }, [searchParams]);

  const filteredList = sourceDetailList
    .filter(
      (e) =>
        activeWorkType.indexOf(e.workTypeId) >= 0 &&
        searchWord(e.equipmentGroupName, searchText)
    )
    .sort((a, b) =>
      isElasticLoad()
        ? b.acres - a.acres
        : a.loadCount === b.loadCount
          ? b.acres - a.acres
          : b.loadCount - a.loadCount
    );

  let hasImplementOnly = true;
  activeWorkType.forEach((id) => {
    if (HARVEST_WORK_TYPE_IDS.indexOf(id) >= 0) hasImplementOnly = false;
  });

  const getEGImageURL = (data, egId) => {
    let egIssue = egReportIssue && egReportIssue[egId] ? egReportIssue[egId] : null;
    return egIssue && !egIssue.is_resolve
      ? data.imgUrl.sm.replace("/sm", "/ic/3")
      : data.imgUrl.sm;
  };

  const showEGReportIcon = (egId) => {
    let egIssue = egReportIssue && egReportIssue[egId] ? egReportIssue[egId] : null;
    return egIssue && !egIssue.is_resolve ? (
      <i
        className="fa fa-exclamation-triangle ml-3"
        style={{ color: "red" }}
        title={egIssue.issue}
      />
    ) : (
      <div></div>
    );
  };

  return (
    <>
      <Card
        className={`implement-type ${hasImplementOnly && activeWorkType.length !== 0 ? "implement-only" : ""
          }`}
      >
        <Col className="h-100 p-0">
          <Row className="search-input">
            <SearchInput
              className="w-100"
              onChange={(searchText) => setSearchText(searchText)}
            />
          </Row>
          <Row className="completion-info">
            <Col className="h-100 p-0">
              <Row className="info-header">
                <div className="name" style={{ width: "33%" }}>
                  Implement
                </div>
                {!isElasticLoad() && <div style={{ width: "15%" }}>Loads</div>}
                <div style={{ width: `${isElasticLoad() ? "32%" : "25%"}` }}>Acres</div>
                <div style={{ width: `${isElasticLoad() ? "35%" : "27%"}` }}>
                  <Row className="ml-2 mt-1"> Utilization % </Row>
                  {isMultipleDate && !isRequestingKpi && (
                    <Row
                      onClick={() => setAll(true)}
                      style={{
                        position: "absolute",
                        left: "313px",
                        fontWeight: "none",
                        cursor: "pointer",
                        borderBottom: "solid 2px rgb(54, 54, 54)",
                      }}
                    >
                      All
                    </Row>
                  )}
                </div>
              </Row>
              <Row
                className={`info-body ${(filteredList.length === 0 || isRequestingEg) &&
                  "align-items-center"
                  }`}
              >
                {isRequestingEg ? (
                  <Col className="no-item-found">Loading...</Col>
                ) : filteredList.length === 0 ? (
                  <Col className="no-item-found">No Records Found</Col>
                ) : (
                  <Col className="p-0">
                    {filteredList.map((item) => (
                      <div key={item.equipmentGroupId}>
                        <div className="eg-card d-flex">
                          <div className="eg-info d-flex">
                            <img
                              src={getEGImageURL(item, item.equipmentGroupId)}
                              alt=""
                              className="image"
                            />
                            <div
                              className="name"
                              title={item.equipmentGroupName}
                            >
                              {item.equipmentGroupName}
                            </div>
                          </div>
                          {!isElasticLoad() && (
                            <div
                              style={{ width: "15%" }}
                              className="value"
                            >
                              {isRequestingLoad || isRequestingLoad ? (
                                <LoadingStyle />
                              ) : item.loadCount === null ? (
                                "-"
                              ) : (
                                item.loadCount
                              )}
                            </div>
                          )}
                          <div
                            style={{
                              width: `${isElasticLoad() ? "32%" : "25%"}`,
                            }}
                            className="value"
                          >
                            {isRequestingKpi ? (
                              <LoadingStyle />
                            ) : item.acres ? (
                              unit.toRoundOfArea(item.acres)
                            ) : (
                              0
                            )}
                          </div>
                          <div
                            style={{
                              width: `${isElasticLoad() ? "35%" : "27%"}`,
                            }}
                            onClick={(e) => {
                              setEgId({
                                egId: item.equipmentGroupId,
                                egName: item.equipmentGroupName,
                              });
                              if (isMultipleDate) {
                                if (
                                  item.utilization &&
                                  Math.round(item.utilization) !== 0
                                ) {
                                  setShow(true);
                                }
                              }
                            }}
                            className="value"
                          >
                            {isRequestingKpi ? (
                              <LoadingStyle />
                            ) : (
                              <span
                                className={`${isMultipleDate
                                    ? item.utilization
                                      ? Math.round(item.utilization) !== 0
                                        ? "utilizationChart"
                                        : null
                                      : null
                                    : null
                                  }`}
                              >
                                {item.utilization
                                  ? Math.round(item.utilization)
                                  : 0}
                                %
                              </span>
                            )}
                            {!isRequestingKpi &&
                              showEGReportIcon(item.equipmentGroupId)}
                          </div>
                        </div>
                        <div className="divider"></div>
                      </div>
                    ))}
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Col>
      </Card>
      {show && (
        <UtilizationModal
          show={show && isMultipleDate}
          onHide={() => setShow(false)}
          searchParams={searchParams}
          eg={egId}
        />
      )}
      {isAll && isMultipleDate && (
        <AllUtilizationModal
          show={isAll && isMultipleDate}
          onHide={() => setAll(false)}
          searchParams={searchParams}
        />
      )}
    </>
  );
};

export default NonTruckList;
